<div fxLayout="row">
    <mza-artikel-bild fxFlex="20" [artikelNr]="beigabe.beigabenArtikel[0]?.artikel?.artikelNr"></mza-artikel-bild>
 <div fxFlex>{{beigabe.beigabenArtikel[0]?.menge}}x {{beigabe.beigabenArtikel[0]?.artikel?.artikelNr}} ab einem Warenwert von {{beigabe.beigabenArtikel[0]?.mindestWarenwert}}€ <br />
     <span ng-if="beigabe.isDirektversand == true">Direktversand</span><br /><span ng-if="beigabe.showInWarenkorb == false">Ohne Warenkorbanzeige</span></div>
</div>
